import React, { useState, useEffect } from "react";
import { Boxed } from "../../components/Boxed.components";
import { Text } from "../../components/Text.components";
import { Uploader } from "../../components/Uploader.components";
import { Grid } from "../../components/Grid.components";
import { AsyncSelect, Input } from "../../components/Input.components";
import { Button } from "../../components/Button.components";

import LOGO from "../../assets/img/logo.png";
import { Theme } from "../../utils/theme";

export const Signup = (props) => {
  // State props
  const { isLoading, isLoadingCallCodes, callCodesList } = props;
  // Dispatch props
  const { form, createCompany, fetchCallCodes } = props;
  const { getFieldProps, getFieldError, validateFields, getFieldValue } = form;
  const [profileImage, setProfileImage] = useState("");
  const [showUploader, setShowUploader] = useState(true);

  useEffect(() => {
    fetchCallCodes();
  }, []);
  const addImage = (e) => {
    const base64Image = `data:${e.type};base64,${e.base64}`;
    setProfileImage(base64Image);
    setShowUploader(false);
  };
  const companySize = [
    {
      label: "1-20",
      value: "1-10",
    },
    {
      label: "21-50",
      value: "21-50",
    },
    {
      label: "51-100",
      value: "51-100",
    },
  ];
  const onSubmit = () => {
    validateFields((error, value) => {
      if (!error) {
        const payload = {
          name: value.companyname.trim(),
          address: value.companyaddress.trim(),
          email: value.companyemail.trim(),
          contactPerson: {
            name: value.contactname.trim(),
            email: value.contactemail.trim(),
            phone: {
              countryCode: value.callCode.value,
              phone: value.contactphone.trim(),
            },
          },
          organizationSize: value.companysize.value,
          companyLogoUrl: profileImage,
        };
        // console.log(payload);
        createCompany(payload);
      }
    });
  };
  console.log({ callCodesList });
  return (
    <Grid desktop="100%" tablet="100%" mobile="100%">
      <Boxed display="flex" width="100%" minHeight="100vh">
        <Boxed margin="auto" minWidth="350px">
          <Boxed pad="10px 0" display="flex">
            <img
              src={LOGO}
              height="100px"
              alt="app_logo"
              style={{ margin: "0 auto" }}
            />
          </Boxed>
          <Boxed
            pad="20px"
            background="#FFFFFF"
            borderRadius={Theme.SecondaryRadius}
            boxShadow={Theme.PrimaryShadow}
          >
            <Text
              fontSize="24px"
              fontWeight="bold"
              margin="5px 0"
              align="center"
            >
              Create Account
            </Text>
            <Text margin="5px 0" align="center">
              Please fill form to create your organization account.
            </Text>
            <Boxed>
              <Boxed margin="10px 0">
                <Text fontWeight={800}>Company Logo</Text>
                {showUploader ? (
                  <Uploader
                    types={["image/png", "image/jpeg"]}
                    message={"Click to add company logo"}
                    callBack={addImage}
                  />
                ) : (
                  <Boxed
                    margin="10px auto"
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    position="relative"
                  >
                    <img
                      src={profileImage}
                      alt="profile"
                      style={{
                        width: "160px",
                        height: "160px",
                        borderRadius: "9999px",
                      }}
                    />
                    <Boxed
                      bColor="#ffff"
                      pad="5px 8px"
                      borderRadius="9999px"
                      position="absolute"
                      bottom="24px"
                      onClick={() => setShowUploader(true)}
                    >
                      <i className="icon-edit-2" style={{ fontSize: "22px" }} />
                    </Boxed>
                  </Boxed>
                )}
              </Boxed>

              <Grid
                desktop="repeat(2, 1fr)"
                tablet="repeat(2, 1fr)"
                mobile="repeat(1,1fr)"
                pad="0 0 30px 0"
              >
                <Boxed pad="10px 0">
                  <Input
                    type="text"
                    label="Company Name"
                    placeholder="Enter company name..."
                    error={
                      getFieldError("companyname")
                        ? "Company name is required"
                        : null
                    }
                    {...getFieldProps("companyname", {
                      initialValue: "",
                      rules: [{ required: true }],
                    })}
                  />
                </Boxed>
                <Boxed pad="10px 0">
                  <Input
                    type="text"
                    label="Company Email"
                    placeholder="Enter Company email..."
                    error={
                      getFieldError("companyemail")
                        ? "Company Email is required"
                        : null
                    }
                    {...getFieldProps("companyemail", {
                      initialValue: "",
                      rules: [{ required: true, email: true }],
                    })}
                  />
                </Boxed>
                <Boxed pad="10px 0">
                  <Input
                    type="text"
                    label="Address"
                    placeholder="Enter company address..."
                    error={
                      getFieldError("companyaddress")
                        ? "Company address is required"
                        : null
                    }
                    {...getFieldProps("companyaddress", {
                      initialValue: "",
                      rules: [{ required: true }],
                    })}
                  />
                </Boxed>
                <Boxed pad="10px 0">
                  <AsyncSelect
                    label="Country"
                    placeholder="Select Country"
                    isLoading={isLoadingCallCodes}
                    // width={"80%"}
                    options={
                      callCodesList?.map((item) => ({
                        label: `${item?.code} ${item?.dial_code}`,
                        value: item?.dial_code,
                      })) ?? []
                    }
                    error={
                      getFieldError("callCode") ? "call code is required" : null
                    }
                    {...getFieldProps("callCode", {
                      initialValue: "",
                      rules: [{ required: true }],
                    })}
                  />
                </Boxed>
                <Boxed pad="10px 0">
                  <Input
                    type="text"
                    label="Contact Name"
                    placeholder="Enter Contact name..."
                    error={
                      getFieldError("contactname")
                        ? "Contact name is required"
                        : null
                    }
                    {...getFieldProps("contactname", {
                      initialValue: "",
                      rules: [{ required: true, email: true }],
                    })}
                  />
                </Boxed>
                <Boxed pad="10px 0">
                  <Input
                    type="text"
                    label="Contact Phone Number"
                    // width={"85%"}
                    placeholder="Enter phone number..."
                    error={
                      getFieldError("contactphone")
                        ? "Contact Phone number is required"
                        : null
                    }
                    {...getFieldProps("contactphone", {
                      initialValue: "",
                      rules: [{ required: true }],
                    })}
                  />
                </Boxed>
                <Boxed pad="10px 0">
                  <Input
                    type="text"
                    label="Contact Email"
                    placeholder="Enter Contact email..."
                    error={
                      getFieldError("contactemail")
                        ? "Contact Email is required"
                        : null
                    }
                    {...getFieldProps("contactemail", {
                      initialValue: "",
                      rules: [{ required: true, email: true }],
                    })}
                  />
                </Boxed>

                <Boxed pad="10px 0">
                  <Input
                    type="text"
                    label="Secondary Contact Email"
                    placeholder="Enter Contact email..."
                    error={
                      getFieldError("contactemail2")
                        ? "Contact Email is required"
                        : null
                    }
                    {...getFieldProps("contactemail2", {
                      initialValue: "",
                      rules: [{ required: false, email: true }],
                    })}
                  />
                </Boxed>

                <Boxed pad="10px 0">
                  <AsyncSelect
                    label="Company Size"
                    placeholder="Select company size"
                    options={companySize}
                    error={
                      getFieldError("companysize")
                        ? "Company Size is required"
                        : null
                    }
                    {...getFieldProps("companysize", {
                      initialValue: "",
                      rules: [{ required: true }],
                    })}
                  />
                </Boxed>
              </Grid>

              <Boxed pad="5px 0 0 0" display="flex" margin="15px 0">
                <Button
                  margin="0 0 0 auto"
                  disabled={isLoading}
                  progress={isLoading}
                  onClick={onSubmit}
                >
                  CREATE ACCOUNT
                </Button>
              </Boxed>
            </Boxed>
          </Boxed>
        </Boxed>
      </Boxed>
    </Grid>
  );
};
